import _ from 'lodash';
import React from 'react';

import {formatDate} from 'utils/datetime';
import Table from 'components/Table';
import Button from 'components/Button';
import circleChecked from 'assets/icons/circle-check.svg';

import './styles.css';

const getAddress = ({country, state, city, street, postcode}) =>
  [country, state, city, street, postcode]
    .filter(x => !_.isEmpty(x))
    .join(', ');

const renderRow = (address, confirmHandler) => (
  <Table.Row key={address.id}>
    <Table.Cell>{getAddress(address)}</Table.Cell>
    <Table.Cell>
      {address.current && <img src={circleChecked} alt={'Checked circle'} />}
    </Table.Cell>
    <Table.Cell>{formatDate(address.createdAt)}</Table.Cell>
    <Table.Cell>{formatDate(address.lastConfirmedCurrent)}</Table.Cell>
    <Table.Cell>
      <Button
        className="confirmCurrentAddress"
        white
        onClick={() => confirmHandler(address.id)}>
        Confirm
      </Button>
    </Table.Cell>
  </Table.Row>
);

const KycAddressHistoryTable = ({
  addressHistory,
  confirmCurrentAddressHandler
}) => (
  <div className="KycAddressHistoryTable KycTable KycHistoryTable">
    <div className="tableHeading">Address History</div>
    <Table>
      <Table.Header>
        <Table.HeaderItem heading="address" />
        <Table.HeaderItem heading="latest" />
        <Table.HeaderItem heading="created" />
        <Table.HeaderItem heading="last verified" />
        <Table.HeaderItem heading="" />
      </Table.Header>
      <Table.Body>
        {addressHistory.map(address =>
          renderRow(address, confirmCurrentAddressHandler)
        )}
      </Table.Body>
    </Table>
  </div>
);

export default KycAddressHistoryTable;
